import {CheckoutStep}         from "./steps/checkout/checkout-step";
import {CustomizeStep}        from "./steps/customize/customize-step";
import {DoneStep}             from "./steps/done/done-step";
import {KitOptionsStep}       from "./steps/kit-options/kit-options-step";
import {OptionsStep}          from "./steps/options/options-step";
import {PhotoIntegrationAuth} from "./steps/customize/photo-integration-auth";
import {PreloadStep}          from "./steps/preload/preload-step";
import {ProductOptionsStep}   from "./steps/product-options/product-options-step";

export const customizeRoutes = [
    {
        path: "/product-options/:product_id",
        component: ProductOptionsStep,
    },
    {
        path: "/product-options/order/:item",
        component: ProductOptionsStep,
    },
    {
        path: "/product-options/:product_id/:idUserCreatedTemplate",
        component: ProductOptionsStep,
    },
    {
        path: "/kit-options/order/:item",
        component: KitOptionsStep,
    },
    {
        path: "/customize/order/:item_id",
        component: CustomizeStep,
    },
    {
        path: "/customize/order/:item_id/:component_id",
        component: CustomizeStep,
    },
    // {
    //     path: "/customize/temp",
    //     component: SocialSharing,
    // },
    {
        path: "/customize/:front_template_id/:back_template_id",
        component: PreloadStep,
    },
    {
        path: "/customize/:front_template_id",
        component: PreloadStep,
    },
    {
        path: "/distribution-options/order/:item_id",
        component: OptionsStep,
    },
    {
        path: "/options/:item_id",
        component: OptionsStep,
    },
    {
        path: "/checkout/:cart_id",
        component: CheckoutStep,
    },
    {
        path: "/checkout-success/:cart_id",
        component: DoneStep,
    },
    {
        path: "/photo-integration-auth",
        component: PhotoIntegrationAuth,
    },
];
